module.exports = __webpack_public_path__ + "img/fontWeightWhite.9f6c5ca0.svg";